import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { withRipple } from '@sinoui/ripple';
import IconButtonInner from './IconButtonInner';
import { spacing } from '@sinoui/theme';
var BaseIconButton = styled(IconButtonInner)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .sinoui-icon-button__ripple {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n  }\n\n  & .sinoui-icon-button__ripple-layout {\n    left: 0px;\n    top: 0px;\n    width: ", "px;\n    height: ", "px;\n  }\n\n  & .sinoui-icon-button__ripple-dense {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n  }\n\n  & .sinoui-icon-button__ripple-layout-dense {\n    left: 0px;\n    top: 0px;\n    width: ", "px;\n    height: ", "px;\n  }\n"], ["\n  & .sinoui-icon-button__ripple {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n  }\n\n  & .sinoui-icon-button__ripple-layout {\n    left: 0px;\n    top: 0px;\n    width: ", "px;\n    height: ", "px;\n  }\n\n  & .sinoui-icon-button__ripple-dense {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n  }\n\n  & .sinoui-icon-button__ripple-layout-dense {\n    left: 0px;\n    top: 0px;\n    width: ", "px;\n    height: ", "px;\n  }\n"])), spacing.unit * 6, spacing.unit * 6, spacing.unit * 3, spacing.unit * 6, spacing.unit * 6, spacing.unit * 4, spacing.unit * 4, spacing.unit * 2, spacing.unit * 4, spacing.unit * 4);
var rippleConfig = {
    center: true,
    rippleClassName: 'sinoui-icon-button__ripple',
    rippleLayoutClassName: 'sinoui-icon-button__ripple-layout',
    fixSize: true,
};
var denseRippleConfig = {
    center: true,
    rippleClassName: 'sinoui-icon-button__ripple-dense',
    rippleLayoutClassName: 'sinoui-icon-button__ripple-layout-dense',
    fixSize: true,
};
var DenseIconButton = withRipple(denseRippleConfig)(BaseIconButton);
var NormalIconButton = withRipple(rippleConfig)(BaseIconButton);
var IconButton = function (props) {
    return props.dense ? (React.createElement(DenseIconButton, __assign({}, props))) : (React.createElement(NormalIconButton, __assign({}, props)));
};
IconButton.displayName = 'IconButton';
IconButton.sinouiName = 'IconButton';
export default IconButton;
var templateObject_1;
//# sourceMappingURL=IconButton.js.map